<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("processing-transfering.purpose.new") }}</span>
      </h2>

      <b-form-tags v-model="form.products" size="lg" class="mb-2" add-on-change no-outer-focus>
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="products">
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value=""> {{ $t("product.text") }}</option>
            </template>
          </b-form-select>

          <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
            </li>
          </ul>
          <b-form-text v-else>
            <span class="text-danger">{{ $t("product.required") }}</span>
          </b-form-text>
        </template>
      </b-form-tags>

      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('processing-transfering.purpose.name')"
      />

      <!-- <b-form-checkbox switch :value="false" disabled :unchecked-value="false" class="custom-checkbox mt-2" checked>
        {{ $t("processing.purpose.is-verbis") }}
      </b-form-checkbox> -->


      <!-- TKP-67: amaç türü. Boş = sınıflandırılmamış; kayıt hem işleme hem aktarım listesinde görünür. -->
      <label class="mt-4">{{ $t("purpose.kind.text") }}</label>
      <select class="form-control" v-model="form.kind">
        <option :value="null">{{ $t("purpose.kind.unclassified") }}</option>
        <option :value="'PROCESSING'">{{ $t("purpose.kind.processing") }}</option>
        <option :value="'TRANSFERING'">{{ $t("purpose.kind.transfering") }}</option>
      </select>
      <label class="mt-4">{{ $t("common.aquivalent-verbis") }}</label>
      <filter-select
        id="purposeFilter"
        ref="purposeFilter"
        :hideVerbisAquivalent="true"
        :placeholder="$t('common.aquivalent-verbis')"
        :multiple="false"
        @filter="onPurposeSearch"
        :selected="form.verbisAquivalent"
        @changed="onPurposeSelect"
      />

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { maxLength, minLength, required, requiredIf } from "vuelidate/lib/validators";
const state = "workspacePurpose";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
    // TKP-67: form hangi listeden/bağlamdan açıldıysa yeni kayıt o türle başlar (işleme formu → PROCESSING).
    kind: { type: String, default: null },
  },
  data() {
    return {
      form: { name: undefined, products: undefined, isVerbisPurpose: false, verbisAquivalent: undefined, kind: this.kind ?? null },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      products: {
        validate() {
          return this.form.products && this.form.products.length > 0;
        },
      },
      verbisAquivalent: {
        required: requiredIf(function(form) {
          return !form.isVerbisPurpose;
        }),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        //vuelidate referansı kayboluyor ve hatalı çalışıyor.
        //this.form = { ...this.prepareFormForEdit(v) };
        Object.assign(this.form, this.prepareFormForEdit(v));
      },
    },
    form: {
      deep: true,
      immediate: true,
      handler(v) {
        this.$v.form.$touch();
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async onPurposeSearch(value, callback) {
      const query = {
        options: { limit: 1000, sort: { [`name.${this.currentLanguage}`]: "asc" } },
        query: { name: { value }, isVerbisPurpose: { value: true, isObject: true } },
      };

      const response = await this.$store.dispatch(`workspacePurpose/paginateForSearch`, query);

      callback(response.data?.docs ?? []);
    },
    onPurposeSelect(item) {
      this.form.verbisAquivalent = item;
    },

    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-processing-transfering-purpose");
        }
        setTimeout(() => this.$emit("onFormSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
